// ============================================================
// Schema.org JSON-LD の生成・注入
// ページ種別が対応していて、かつ事実がページ上の表示内容と一致する場合のみ生成します。
// ============================================================

import { site } from "@/config/site";
import { images } from "@/config/images";
import { products } from "@/mocks/products";
import { getSiteOrigin } from "@/config/seo";

const productImageMap: Record<string, string> = {
  product1: images.product1,
  product2: images.product2,
  product3: images.product3,
  product4: images.product4,
};

function buildLocalBusiness(origin: string) {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: site.companyName,
    description:
      "長崎県佐世保市の女猟師が営むジビエ食肉加工。捕獲した猪を止め刺し・血抜き・精肉まで一人で行い、命を無駄なく循環させるジビエ猪肉を全国へ通販・販売しています。",
    url: origin,
    logo: images.logo,
    image: images.logo,
    telephone: site.phone,
    email: site.email,
    address: {
      "@type": "PostalAddress",
      addressCountry: "JP",
      addressRegion: "長崎県",
      addressLocality: "佐世保市",
      streetAddress: "日宇町1094-1",
    },
    areaServed: "長崎県佐世保市",
  };
}

function buildItemList() {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "株式会社MEGURI 商品一覧",
    itemListElement: products.map((p, i) => {
      const isSoldOut = "soldOut" in p && p.soldOut;
      return {
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Product",
          name: p.name,
          description: p.description,
          image: productImageMap[p.imageKey],
          offers: {
            "@type": "Offer",
            price: String(p.price),
            priceCurrency: "JPY",
            availability: isSoldOut
              ? "https://schema.org/OutOfStock"
              : "https://schema.org/InStock",
          },
        },
      };
    }),
  };
}

export function buildJsonLdForPath(path: string): Record<string, unknown>[] {
  const origin = getSiteOrigin();
  switch (path) {
    case "/":
      return origin ? [buildLocalBusiness(origin)] : [];
    case "/products":
      return [buildItemList()];
    default:
      return [];
  }
}

// JSON-LD はメタタグの更新処理とは分離して、専用の関数で注入します。
export function applyJsonLd(path: string): void {
  document
    .querySelectorAll('script[data-seo-jsonld="true"]')
    .forEach((el) => el.remove());

  const list = buildJsonLdForPath(path);
  for (const obj of list) {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-jsonld", "true");
    script.textContent = JSON.stringify(obj);
    document.head.appendChild(script);
  }
}